/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2245
 */

"use strict"

module.exports = require(/* 2246 */"./2246")
